import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import profile from './modules/profile'
import song from './modules/song'
import payment from './modules/payment'
import live from './modules/live'
import player from './modules/player'
import feed from './modules/feed'
import playlist from './modules/playlist'
import search from './modules/search'
import flash from './modules/flash'
import artist from './modules/artist'
import realtime from './modules/realtime'
import social from './modules/social'
import config from './modules/config'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    profile,
    song,
    payment,
    live,
    player,
    feed,
    playlist,
    search,
    flash,
    artist,
    realtime,
    social,
    config
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js